export default __webpack_public_path__ + "static/media/iconfinder_i124_902938 copy.17bfa949.svg";